import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const tagType = ['red', 'green'];
const tagText = ['未完成', '已完成'];

const columns = utils.columns([
    {key:'$index', label: '序号' , width: 75},
    {key:'listenOrgName', label: '评价人部门' , width: 120},
    {key:'listenEmployeeName', label: '评价人姓名' , width: 120 },
    {key:'listenEmployeeCode', label: '评价人工号', width: 120},
    {key:'listenedOrgName', label: '被评价人部门', width: 120 },
    {key:'listenedEmployeeName', label: '被评价人姓名', width: 120 },
    // {key:'listenedEmployeeCode', label: '被评价人工号' , width: 120},
    {key:'listenStatu', label: '评价完成情况',width: 120, render: (val) => {
        const type = tagType[val-1];
        return <Tag color={type}>{tagText[val-1]}</Tag>
    } },    
    {key:'listenTypeDesc', label: '评价类型', width: 100},
    {key:'listenedTypeDesc', label: '被评价类型', width: 100},
    // {key:'shouldCount', label: '应评次数', width: 75},
    {key:'currentCount', label: '当前评论次数', width: 120},
    {key:'limitCount', label: '可评次数', width: 100},
    {key:'expiryDate' , label : '截止日期', width: 100},
    {key:'termName', label : '所属学期'}
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;
    var params = [];
    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        }  else if(i === 'order'){
            params.push(`order=${keywords[i]}`);
        } else {
        }
    }

    return fetch.post('/listen/generate/query?'+ params.join('&'),  Object.assign(defaultsParams, keywords))
    // return fetch.mockget('http://test.gxjxcp.com:8888/mock/11/jxcp-webapp/listenManager')
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({ 
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
}